import { differenceInSeconds } from 'date-fns';

export const calculateAvailableToResendIn = (availableToResendAt?: string) => {
    if (!availableToResendAt) return 0;
    const timeLeft = differenceInSeconds(new Date(availableToResendAt), new Date());

    return timeLeft > 0 ? timeLeft : 0;
};
